import React, { useEffect, useState } from "react";
import "./ViewLead.css";
import { BsPencilSquare } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import { RiAddBoxLine } from "react-icons/ri";
// import { AiOutlineTable } from "react-icons/ai";
import { FaRegFilePdf } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
// import AddIcon from "@mui/icons-material/Add";
import Sidebar from "../../../Sidebar/Sidebar";
// import Switch from "@mui/material/Switch";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ReactPaginate from "react-paginate";
// import { AiOutlineFileExcel } from "react-icons/ai";
// import { AiOutlineFilePdf } from "react-icons/ai";F
// import { Button } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../../App";
import Cookies from 'js-cookie';
import PDFViewer from '../../Borrower/BorrowerDetails/Components/PDFViewer/PDFViewer'
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { CgDetailsMore } from "react-icons/cg";
import styles from "../../Borrower/BorrowerDetails/BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";

// const label = { inputProps: { "aria-label": "Switch demo" } };

export default function ViewLead() {
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);

  const [leads, setLeads] = useState([]);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [rowNumber, setRowNumber] = useState(10);
  var [pageCount, setPageCount] = useState(1);
  const [visible, setvisible] = useState(false);
  const [EditLeadVisible, setEditLeadVisible] = useState(false);
  const [DeleteLeadVisible, setDeleteLeadVisible] = useState(false);
  const [LeadToBorrowerVisible, setLeadToBorrowerVisible] = useState(false);
  const [bureauPdf, setBureauPdf] = useState('')
  const [openDialog, setOpenDialog] = useState(false);
  const [borrower_unique_number, setBorrower_unique_number] = useState('');
  const [selectedLead, setSelectedLead] = useState(null);

  const [query, setQuery] = useState("");

  const [ip, setIp] = useState('');
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [otherData, setOtherData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [loanNumbers, setLoanNumbers] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [currentLead, setCurrentLead] = useState(null);
  const [openAdditionalModal, setOpenAdditionalModal] = useState(false);
  const [motherTongue, setmotherTongue] = useState("");
  const [motherMaiden, setmotherMaiden] = useState("");
  const [category, setcategory] = useState("");
  const [religion, setreligion] = useState("");
  const [educationalQualification, setEducationalQualification] = useState("");
  const [title, setTitle] = useState("");
  const [fathersName, setFathersName] = useState("");
  const [selfPhoto, setSelfPhoto] = useState("");
  const [panCard, setPanCard] = useState("");

  const fetch = async () => {
    try {
      const { data } = await axios.get('https://api.ipify.org')
      setIp(data);
    } catch (error) {
      toast.error(error.message)
    }

  }

  useEffect(() => {
    fetch()
  }, [])

  useEffect(() => {

    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          // console.log(res);
          setEditLeadVisible(res.data[0].permission.edit_lead);
          setDeleteLeadVisible(res.data[0].permission.delete_lead);
          setLeadToBorrowerVisible(res.data[0].permission.add_borrower);
        })
        .catch((err) => {
          // console.log(err);
        })
    };

    setOpen(true);
    axios
      .post(url + "/lead/getall", {
        token: token,
        email: email,
        pageSize: rowNumber,
        page: pageCount,
      })
      .then((res) => {
        console.log(res);
        setOpen(false);
        if (res.data.logout === true) {
          setOpen(false);
          setTimeout(() => {
            toast.error(res.data.message);
            navigate("/");
          }, 3000);
        }
        else if (res.data.auth === false) {
          setOpen(false);
          // toast.error(res.data.message);
        } else {
          setOpen(false);
          if (res.data.message.length === 0 && pageCount > 1)
            return setPageCount((pageCount) => pageCount - 1);
          console.log(res.data.message)
          setLeads(res.data.message);
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
      });

    // eslint-disable-next-line
  }, [token, email, pageCount, rowNumber, navigate]);

  const handleDeleteLead = (lead_id) => {
    let text = "Are you sure you want to delete " + lead_id + "?";
    if (window.confirm(text) === true) {
      axios
        .post(url + "/lead/delete", {
          token: token,
          hostname: window.location.hostname,
          ip: ip,
          email: email,
          lead_id: lead_id,
        })
        .then((res) => {
          // // console.log(res);
          if (res.data.auth === true) {
            toast.success(res.data.message);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
            axios
              .post(url + "/lead/getall", {
                token: token,
                email: email,
              })
              .then((res) => {
                if (res.data.auth === false) {
                  toast.error(res.data.message);
                  navigate("/");
                } else {
                  // toast.success("Leads Fetched Successfully");
                  setLeads(res.data.reverse());
                }
              })
              .catch((err) => {
                // console.log(err);
                // toast.dismiss("custom");
                toast.error(err);
              });
          } else {
            toast.error(res.data.message);
            // console.log(res);
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });

      // toast.info("Fetching Details...", {
      //   autoClose: false,
      //   toastId: "custom",
      // });
    }
  };

  const handleConvertToBorrower = (lead_id, lead) => {
    console.log(lead, lead_id);
    setSelectedLead(lead);
    if (!title || !educationalQualification || !fathersName || !motherMaiden || !motherTongue || !category || !religion || !selfPhoto || !panCard) return toast.error("Mandatory field cannot be empty.")
    let text = "Are you sure you want to convert " + lead_id + " to borrower ?";
    if (window.confirm(text) === true) {
      // toast.info("Converting Lead to Borrower...", {
      //   autoClose: false,
      //   toastId: "custom",
      // });
      setOpenAdditionalModal(true);
      axios
        .post(url + "/borrower/addpersonal", {
          token: token,
          email: email,
          lead_id: lead_id,
          title: title,
          education: educationalQualification,
          fatherName: fathersName,
          motherName: motherMaiden,
          motherTongue: motherTongue,
          category: category,
          religion: religion,
        })
        .then((res) => {
          // console.log(res);
          // Commenting DigiLocker section
          // if (res.data.auth === '1') {
          //   setBorrower_unique_number(res.data.unique_no);
          //   setOpenDialog(true);
          // } else 
          if (res.data.auth === true) {
            // toast.dismiss("custom");
            setOpenAdditionalModal(false);
            setSelfPhoto("");
            setPanCard("");
            toast.success(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000,
            });
            // window.alert('eKyc initiated for Borrower. Please check borrower mobile for link');
            setBorrower_unique_number(res.data.unique_no);
            // let kycMode = 'DECENTRO';
            // let kycStatus = 'INITIATED';
            setTimeout(() => {
              navigate("/borrower/view", {
                // state: { lead, borrower_unique_number, kycMode, kycStatus },
                // state: { lead: lead, borrower_unique_number: res.data.unique_no, kycMode: kycMode, kycStatus: kycStatus },
                state: { lead: lead, borrower_unique_number: res.data.unique_no },
              });
            }, 4000);
          }
          if (res.data.auth === false) {
            // console.log(res.data.message);
            // toast.dismiss("custom");
            setOpenAdditionalModal(false);
            setSelfPhoto("");
            setPanCard("");
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // toast.dismiss("custom");
          setOpenAdditionalModal(false);
          setSelfPhoto("");
          setPanCard("");
          toast.error(err);
        });
    }
  };

  const handleConvertToCoapplicant = async (lead_id, lead) => {
    console.log('clicked to convert');
    setModalVisible(true);
    setCurrentLead(lead);
    console.log('1');

    try {
      const loansCreated = await axios.post(url + "/loan/loansByMapping", {
        email: email,
        token: token,
      });
      console.log(loansCreated.data, 'res1')
      if (loansCreated.data.auth === true) {
        const formatted = loansCreated.data.message.map((num) => ({ label: num, value: num }));
        setLoanNumbers(formatted);
      } else {
        setLoanNumbers([]);
      }
    } catch (error) {
      setLoanNumbers([]);
      console.log("Error fetching loan numbers:", error);
    }
  }

  const handleConfirmLoan = async () => {
    console.log(currentLead)
    console.log(selectedLoan);
    if (!selectedLoan) {
      toast.error('No loans selected');
      return;
    }
    console.log("Selected loan number:", selectedLoan);
    setModalVisible(false);

    try {
      const createCoapplicant = await axios.post(url + "/coapplicant/convertFromLead", {
        email: email,
        token: token,
        lead: currentLead,
        lead_id: currentLead.lead_id,
        loan_id: selectedLoan,
        identifier: 'fromLead'
      });
      if (createCoapplicant.data.auth === true) {
        toast.success('Coapplicant created successfully');
        setSelectedLoan(null);
      } else {
        toast.error('Error in creating coapplicant');
        setSelectedLoan(null);
      }
    } catch (error) {
      console.error("Error creating coapplicant");
      setSelectedLoan(null);
    }
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedLoan(null);
  };

  const handleChoice = async (choice, lead_id, lead) => {
    console.log("Selected choice", choice);
    console.log(lead_id);
    console.log(lead);
    let userChoice;
    if (!choice) {
      userChoice = 'eKyc'
    } else {
      userChoice = choice;
    }
    const { lead_mobile, lead_firstname, lead_lastname } = lead;
    let name = lead_firstname + ' ' + lead_lastname
    try {
      setOpenDialog(false);
      const callKycApi = await axios.post(url + "/borrower/initiatekyc", {
        kycType: userChoice,
        borrowerNo: borrower_unique_number,
        borrowerMobile: lead_mobile,
        borrowerName: name
      })

      if (callKycApi.data.auth === true) {
        console.log('arrived');
        toast.success('Borrower added', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
        });
        window.alert('eKyc initiated for Borrower. Please check borrower mobile for link');
        let kycMode = userChoice === 'eKyc' ? 'DIGIO EKYC' : 'DIGIO PHYSICAL';
        let kycStatus = 'INITIATED';
        setTimeout(() => {
          navigate("/borrower/lead", {
            state: { lead, borrower_unique_number, kycMode, kycStatus }
          });
        }, 4000);
      } else {
        console.log(callKycApi.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const abc = (leadBirthday) => {
  //   let newDate = new Date(leadBirthday);
  //   return (`${newDate.getDate() < 10 ? "0"+(newDate.getDate()):newDate.getDate()}-${newDate.getMonth() + 1 < 10 ? "0"+(newDate.getMonth() + 1) : (newDate.getMonth() + 1)}-${newDate.getFullYear()}`);
  // }


  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  // const [currentPage, setCurrentPage] = useState(0);

  // const handlePageChange = ({ selected }) => {
  //   setCurrentPage(selected);
  // };
  // const itemsPerPage = rowNumber;

  // const pageCount = Math.ceil(leads.length / itemsPerPage);

  // const getItemsForPage = (items, page) => {
  //   const startIndex = page * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   return items.slice(startIndex, endIndex);
  // };

  const getPageLoad = (e) => {
    // setOpen(true);
    if (e === "inc") {
      setPageCount((pageCount) => pageCount + 1);
    } else {
      setPageCount((pageCount) => pageCount - 1);
    }
  };


  const serachDateApi = () => {
    setOpen(true);
    axios
      .post(url + "/lead/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query.trimStart().trimEnd(),
      })
      .then((res) => {
        // console.log(res);
        setOpen(false);

        if (res.data.auth === false) {
          setOpen(false);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          toast.error(res.data.message);
        }
        else {
          setOpen(false);
          if (res.data.message.length === 0) {
            toast.error("Leads Not Found !");
            return setLeads([]);
          }
          setLeads(res.data.message);
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
        toast.error(err.message);
      });
  };
  const refresh = function () {
    setOpen(true);
    setPageCount(1);
    setRowNumber(10);
    axios
      .post(url + "/lead/getall", {
        token: token,
        email: email,
        pageSize: 10,
        page: 0,
      })
      .then((res) => {
        console.log(res);
        setOpen(false);
        if (res.data.logout === true) {
          setOpen(false);
          // setTimeout(() => {
          toast.error(res.data.message);
          navigate("/");
          //  }, 3000);
        }
        else if (res.data.auth === false) {
          setOpen(false);
          // toast.error(res.data.message);
        } else {
          setOpen(false);
          if (res.data.message.length === 0 && pageCount > 1)
            return setPageCount((pageCount) => pageCount - 1);
          console.log(res.data.message)
          setLeads(res.data.message);

        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
      });
    toast.success("Leads Fetched successfully !");
  }
  useEffect(() => {
    if (query && query.length > 0) {
      const debounceTimer = setTimeout(() => {
        serachDateApi();
      }, 500);
      return () => {
        clearTimeout(debounceTimer);
      };
    }
    else {
      refresh();
    }
    // eslint-disable-next-line
  }, [query])

  const fetchBureauPdf = async (pdfKey) => {
    console.log(pdfKey)
    try {
      let response = await axios.post(`${url}/lead/fetch/pdf`, {
        leadKeyId: pdfKey
      })
      setBureauPdf(`data:application/pdf;base64,${response.data.bureauPdf}`)
      console.log(response.data.bureauPdf)
    } catch (err) {
      console.log(err)
      toast.error(err.response.data.message)
    }
  }

  const closePdfViewer = () => {
    setBureauPdf('')
  };

  function maskMobileNumber(number) {
    if (number && number.length >= 10) {
      const visibleDigits = number.slice(-4);
      const maskedDigits = '*'.repeat(number.length - 4);
      return maskedDigits + visibleDigits;
    }
    return number;
  }

  const otherDetailsModal = (lead_other_data) => {
    console.log(lead_other_data);
    setOtherData([lead_other_data?.loanDetails]);
    setShowOtherDetails(!showOtherDetails);
  }

  const closeFunction = () => {
    setOtherData([]);
    setShowOtherDetails(!showOtherDetails);
  };

  if (showOtherDetails) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  function formatDateTimeIST(dateString) {
    if (!dateString) return '';

    const date = new Date(dateString);

    return new Intl.DateTimeFormat('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(date);
  }

  const handleFileUpload = async (docName, file) => {
    console.log("reached")
    try {
      setOpenAdditionalModal(true);

      if (!file) {
        // setOpenAdditionalModal(false);
        return;
      }

      let doc_type = file.name.split(".").pop();
      const allowed = ["jpg", "jpeg", "png", "pdf", "xlsx"];

      if (!allowed.includes(doc_type)) {
        // setOpenAdditionalModal(false);
        toast.error("Only JPG, PNG, JPEG, PDF or Excel files allowed");
        return;
      }

      if (doc_type === "jpg") doc_type = "jpeg";

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async (ev) => {
        const base64Data = ev.target.result.split(",").pop();
        const payload = {
          lead_id: selectedLead.lead_id,
          doc_name: docName,
          doc_type: doc_type,
          fileName: base64Data,
          token,
          email,
        };

        const res = await axios.post(url + "/lead/adddocument", payload);
        if (!res.data.auth) {
          toast.error(res.data.message);
          // setOpenAdditionalModal(false);
          return;
        }
        toast.success("Document uploaded successfully.");
        // setOpenAdditionalModal(false);
        return;
      };
    } catch (err) {
      console.error(err);
      // setOpenAdditionalModal(false);
      toast.error("Upload failed");
      return;
    }
  };

  return (
    // <div className="background-view-lead">
    //   <div className="container-view-lead">
    //     <div className="viewLead">
    //       <h2 className="h2-view-lead">Lead</h2>
    //       <Link to="/lead/add" style={{ textDecoration: "none" }}>
    //         <button className="addBtn-view-lead">
    //           <AddIcon />
    //           Add
    //         </button>
    //       </Link>
    //     </div>

    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"ViewLead"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container-view-lead">
          <div className="content-container-view-lead">
            {/* <h2 className="main-heading">
              <AiOutlineTable />
              View Leads
            </h2> */}
            <div className="table-lead-input-fields">
              <div className="table-head-inputs">
                {/* <label>Search Data</label> */}
                <TextField
                  placeholder="Lead Id / Mobile No / Lead Email / Pan No"
                  name="search-data"
                  autoComplete="off"
                  id="search-data"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  variant="outlined"
                  size="small"

                />
              </div>

              <button className="digi-kyc" onClick={serachDateApi}>
                Search
              </button>
              <Tooltip title="Refresh">
                <button onClick={refresh}>
                  <RefreshIcon style={{ color: "blue", cursor: 'pointer', fontSize: "25px" }} />
                </button>
              </Tooltip>

              <div className="heading-dl-btns">
                {/* <Button>
                  <AiOutlineFileExcel
                    className="xl-btn"
                    // onClick={handleExcelExport}
                  />
                </Button> */}
                {/* <Button>
                  <AiOutlineFilePdf className="pdf-btn" />
                </Button> */}
              </div>
            </div>
            {/* {leads.length > 0 && (
          <> */}
            <div style={{ borderRadius: '20px', position: 'relative', overflow:'hidden',
              boxShadow:'4px 4px 10px rgba(0, 0, 0, 0.3)'
            }}>
              <TableContainer component={Paper}
                className="scroll-rounded"
                sx={{
                  maxHeight: "65vh",
                  minHeight: "65vh",
                  overflowY: 'scroll',
                  borderRadius: "20px",
                  boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.3)',
                  // position: 'relative'
                }}>
                <Table stickyHeader >
                  <TableHead>
                    <TableRow>
                      {[
                        "Name",
                        "Mobile No.",
                        "Lead Id",
                        "Score",
                        "Status",
                        "Branch Name",
                        "Source",
                        "Created Date/Time",
                        "Lead Type",
                        "Borrower Id",
                        "Action"
                      ].map((head) => {
                        return (<TableCell
                          key={head}
                          align="center"
                          sx={{
                            fontWeight: 600,
                            backgroundColor: "#ced1d8",
                            py:2
                          }}
                        >
                          {head}
                        </TableCell>)
                      })
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* {getItemsForPage(leads, currentPage)
                    ?.filter((user) =>
                      user.lead_id?.toLowerCase().includes(query)
                    ) */}
                    {leads.length > 0 &&
                      leads?.map((lead, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell
                              sx={{
                                wordWrap: "break-word",
                                maxWidth: "150px",
                                py:"1.2rem"
                              }}
                            >
                              {lead.lead_firstname} {lead.lead_middlename}{" "}
                              {lead.lead_lastname}
                            </TableCell>
                            <TableCell sx={{py:2}}>{maskMobileNumber(lead.lead_mobile)}</TableCell>
                            {/* <td>{lead.lead_mobile}</td> */}
                            <TableCell>{lead.lead_id}</TableCell>

                            <TableCell>{lead.lead_credit_score ? lead.lead_credit_score : "-"}</TableCell>
                            <TableCell>{lead.lead_status ? lead.lead_status : "-"}</TableCell>
                            <TableCell>{lead.lead_branchname ? lead.lead_branchname : "-"}</TableCell>
                            <TableCell>{lead.lead_source}</TableCell>
                            {/* <td>{(lead.lead_connector_name)?.toUpperCase()}</td> */}
                            <TableCell>{formatDateTimeIST(lead.lead_created_date)}</TableCell>
                            <TableCell>{lead.lead_type ? lead.lead_type : "-"}</TableCell>
                            <TableCell>{lead.borrower_uniqueno ? lead.borrower_uniqueno : "-"}</TableCell>
                            <TableCell className="table-data-view-lead">
                              {(EditLeadVisible || visible) && (
                                <Link to="/lead/edit" state={lead}>
                                  <button
                                    className="icon-btn-view-lead"
                                    title="Edit Lead"
                                  >
                                    <BsPencilSquare
                                      // fontSize="small"
                                      style={{ fontSize: "16px" }}
                                    />
                                  </button>
                                </Link>
                              )}

                              {/* <Switch
                        // {...label}
                        defaultChecked
                        size="small"
                        color="success"
                      /> */}
                              {(DeleteLeadVisible || visible) && (
                                <button
                                  className="icon-btn-view-lead"
                                  title="Delete Lead"
                                >
                                  <RiDeleteBinLine
                                    style={{
                                      color: "#eb1c24",
                                      fontSize: "18px",
                                      marginLeft: ".5rem",
                                    }}
                                    role="button"
                                    onClick={() => handleDeleteLead(lead.lead_id)}
                                  />
                                </button>
                              )}

                              {(!lead.borrower_uniqueno || lead.borrower_uniqueno === "") && (LeadToBorrowerVisible || visible) &&
                                <button
                                  className="icon-btn-view-lead"
                                  title="Convert To Borrower"
                                >
                                  <RiAddBoxLine
                                    fontSize="small"
                                    style={{
                                      color: "green",
                                      fontSize: "18px",
                                      marginLeft: ".5rem",
                                    }}
                                    onClick={() =>
                                    // handleConvertToBorrower(lead.lead_id, lead)
                                    {
                                      if (lead.lead_type === "Borrower") {
                                        // handleConvertToBorrower(lead.lead_id, lead);
                                        setSelectedLead(lead);
                                        setOpenAdditionalModal(true);
                                      } else if (lead.lead_type === "CoBorrower") {
                                        handleConvertToCoapplicant(lead.lead_id, lead);
                                      }
                                    }
                                    }
                                  />
                                </button>
                              }

                              <button
                                className="icon-btn-view-lead"
                                title="Credit Report"
                              >
                                <FaRegFilePdf
                                  fontSize="small"
                                  style={{
                                    color: "green",
                                    fontSize: "16px",
                                    marginLeft: ".5rem",
                                  }}
                                  onClick={() =>
                                    fetchBureauPdf(lead.lead_bureau_pdf_key)
                                  }
                                />
                              </button>
                              {lead.lead_other_data ? (
                                <button
                                  className="icon-btn-view-lead"
                                  title="Other Details"
                                >
                                  <CgDetailsMore
                                    fontSize="small"
                                    style={{
                                      color: "black",
                                      fontSize: "18px",
                                      marginLeft: ".5rem",
                                    }}
                                    onClick={() =>
                                      otherDetailsModal(lead.lead_other_data)
                                    }
                                  />
                                </button>
                              ) : ""}
                              {selectedLead && selectedLead.lead_id === lead.lead_id && (
                                <Dialog open={openDialog}>
                                  <DialogTitle>Choose KYC Option to proceed</DialogTitle>
                                  <DialogContent sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Button variant="contained" sx={{ margin: '0.5rem' }} onClick={() => handleChoice('eKyc', lead.lead_id, lead)}>e-Kyc</Button>
                                    <Button variant="contained" sx={{ margin: '0.5rem' }} onClick={() => handleChoice('Physical', lead.lead_id, lead)}>Physical KYC</Button>
                                  </DialogContent>
                                </Dialog>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                </Table>

              </TableContainer>
              <Backdrop
                open={open}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 10,
                  color: "#fff",
                  minHeight: '65vh',
                  maxHeight: '65vh',
                  borderRadius: '20px',
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                
                }}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>

            {modalVisible && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h3 className="modal-title">
                    Select Loan Number for which Coapplicant needs to be created
                  </h3>

                  <select
                    className="dropdown"
                    value={selectedLoan}
                    onChange={(e) => setSelectedLoan(e.target.value)}
                  >
                    <option value="">Select Loan Number</option>
                    {loanNumbers.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>

                  <div className="button-row">
                    <button className="confirm-button" onClick={handleConfirmLoan}>
                      Confirm
                    </button>

                    <button
                      className="confirm-button close-button"
                      onClick={handleCloseModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {openAdditionalModal && (
              <div className={styles.profileDetailsModal}>
                <div
                  className={styles.profileDetailsModaOverlay}
                  onClick={(e) =>
                    e.target === e.currentTarget && setOpenAdditionalModal(false)
                  }
                >
                  <div className={styles.profileDetailsModalContent} >
                    <h3>Additional Details</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                      {/* Title */}
                      <div className="input-item" style={{ marginTop: "20px" }}>
                        <label>Title*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          fullWidth
                          required
                          name="title"
                          value={title}
                          size="small"
                          onChange={(e) => setTitle(e.target.value)}
                        >
                          <MenuItem value="MR">MR</MenuItem>
                          <MenuItem value="MRS">MRS</MenuItem>
                          <MenuItem value="MS">MS</MenuItem>
                        </TextField>
                      </div>

                      {/* Educational Qualification */}
                      <div className="input-item">
                        <label>Educational Qualification*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          fullWidth
                          name="educational-qualification"
                          value={educationalQualification}
                          size="small"
                          onChange={(e) =>
                            setEducationalQualification(e.target.value)
                          }
                        >
                          <MenuItem value="ILLITERATE">ILLITERATE</MenuItem>
                          <MenuItem value="10TH">10TH</MenuItem>
                          <MenuItem value="12TH">12TH</MenuItem>
                          <MenuItem value="GRADUATE">GRADUATE</MenuItem>
                          <MenuItem value="POST-GRADUATE">POST-GRADUATE</MenuItem>
                        </TextField>
                      </div>

                      {/* Father's Name */}
                      <div className="input-item">
                        <label>Father's Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          fullWidth
                          name="father-name"
                          required
                          value={fathersName}
                          onChange={(e) => setFathersName(e.target.value)}
                          placeholder="Father's Name"
                          size="small"
                        />
                      </div>

                      {/* Mother's Maiden Name */}
                      <div className="input-item">
                        <label>Mother's Maiden Name*</label>
                        <br />
                        <TextField
                          className="input-field"
                          fullWidth
                          name="mother-maiden"
                          required
                          value={motherMaiden}
                          onChange={(e) => setmotherMaiden(e.target.value)}
                          size="small"
                        />
                      </div>

                      {/* Mother Tongue */}
                      <div className="input-item">
                        <label>Mother Tongue*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          fullWidth
                          value={motherTongue}
                          size="small"
                          onChange={(e) => setmotherTongue(e.target.value)}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="HINDI">Hindi</MenuItem>
                          <MenuItem value="GUJARATI">Gujarati</MenuItem>
                          <MenuItem value="ENGLISH">English</MenuItem>
                        </TextField>
                      </div>

                      {/* Category */}
                      <div className="input-item">
                        <label>Category*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          fullWidth
                          value={category}
                          size="small"
                          onChange={(e) => setcategory(e.target.value)}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="GENERAL">GENERAL</MenuItem>
                          <MenuItem value="SC">SC</MenuItem>
                          <MenuItem value="ST">ST</MenuItem>
                          <MenuItem value="OBC">OBC</MenuItem>
                          <MenuItem value="OTHER">OTHER</MenuItem>
                        </TextField>
                      </div>

                      {/* Religion */}
                      <div className="input-item">
                        <label>Religion*</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          fullWidth
                          value={religion}
                          size="small"
                          onChange={(e) => setreligion(e.target.value)}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="HINDU">Hindu</MenuItem>
                          <MenuItem value="MUSLIM">Muslim</MenuItem>
                          <MenuItem value="SIKH">Sikh</MenuItem>
                          <MenuItem value="CHRISTIAN">Christian</MenuItem>
                          <MenuItem value="JAIN">Jain</MenuItem>
                          <MenuItem value="BUDDHISM">Buddhism</MenuItem>
                        </TextField>
                      </div>

                      <div className="input-item">
                        <label>Self Photo</label>
                        <input
                          type="file"
                          className="input-field"
                          onChange={(e) => {
                            handleFileUpload("self_photo", e.target.files[0])
                            setSelfPhoto(e.target.files[0])
                          }}
                        />
                      </div>

                      <div className="input-item">
                        <label>Pan Card</label>
                        <input
                          type="file"
                          className="input-field"
                          onChange={(e) => {
                            handleFileUpload("pan_card", e.target.files[0])
                            setPanCard(e.target.files[0])
                          }}
                          style={{ marginBottom: "20px" }}
                        />
                      </div>

                    </div>

                    {/* Buttons */}
                    <div className="button-row" style={{ display: "flex", flexDirection: "row" }}>
                      <button
                        className="confirm-button close-button"
                        onClick={() => {
                          setOpenAdditionalModal(false);
                          setSelfPhoto("");
                          setPanCard("");
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        className="confirm-button"
                        onClick={() => {
                          handleConvertToBorrower(
                            selectedLead.lead_id,
                            selectedLead
                          );
                          // setOpenAdditionalModal(false);
                        }}
                      >
                        Submit
                      </button>
                    </div>

                    <div
                      className={styles.CloseIcon}
                      onClick={() => {
                        setOpenAdditionalModal(false);
                        setSelfPhoto("");
                        setPanCard("");
                      }}
                    >
                      <CloseIcon />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="pagination-div-view">
              <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div>
              <div className="pagination-bar">
                <button
                  className="digi-kyc"
                  onClick={() => getPageLoad("dec")}
                  disabled={pageCount === 1}
                  style={{ marginLeft: "1rem" }}
                >
                  Previous
                </button>
              </div>
              <span className="pageCount" style={{ margin: "1rem" }}>
                {pageCount}
              </span>
              <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>
                  Next
                </button>
              </div>
            </div>
          </div>
          {showOtherDetails && (
            <div className="modal-table overlay-viewlead">
              <div className="modal-content-viewlead">
                <h2 style={{ width: "100%", textAlign: "center" }}>
                  Other Details
                </h2>
                <br />
                <div className="lms-table-div-modal">
                  <table className="modal-table">
                    <tbody>
                      {
                        otherData && otherData?.map((data, index) => {
                          return (
                            <>
                              {data?.buffaloMilkProductionPerDay && (
                                <tr>
                                  <th>Buffalo Milk Production Per Day</th>
                                  <td>{data?.buffaloMilkProductionPerDay}</td>
                                </tr>
                              )}
                              {data?.buffaloToBePurchased && (
                                <tr>
                                  <th>Buffalo To Be Purchased</th>
                                  <td>{data?.buffaloToBePurchased}</td>
                                </tr>
                              )}
                              {data?.cowMilkProductionPerDay && (
                                <tr>
                                  <th>Cow Milk Production Per Day</th>
                                  <td>{data?.cowMilkProductionPerDay}</td>
                                </tr>
                              )}
                              {data?.cowsToBePurchased && (
                                <tr>
                                  <th>Cows To Be Purchased</th>
                                  <td>{data?.cowsToBePurchased}</td>
                                </tr>
                              )}
                              {data?.exisitngCows && (
                                <tr>
                                  <th>Exisitng Cows</th>
                                  <td>{data?.exisitngCows}</td>
                                </tr>
                              )}
                              {data?.existingBuffalo && (
                                <tr>
                                  <th>Existing Buffalo</th>
                                  <td>{data?.existingBuffalo}</td>
                                </tr>
                              )}
                              {data?.income && (
                                <tr>
                                  <th>Income</th>
                                  <td>{data?.income}</td>
                                </tr>
                              )}
                              {data?.pincode && (
                                <tr>
                                  <th>Pincode</th>
                                  <td>{data?.pincode}</td>
                                </tr>
                              )}
                              {data?.quantity && (
                                <tr>
                                  <th>Quantity</th>
                                  <td>{data?.quantity}</td>
                                </tr>
                              )}
                              {data?.supplyingTo && (
                                <tr>
                                  <th>Supplying To</th>
                                  <td>{data?.supplyingTo}</td>
                                </tr>
                              )}
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <br />
                <button className="close-modal" onClick={() => closeFunction()}>
                  CLOSE
                </button>
              </div>
            </div>
          )}
        </div>
        <ToastContainer />
        {bureauPdf && (
          <PDFViewer url={bureauPdf} closeModal={closePdfViewer} />
        )}

      </div >
    </>
  );
}